/**
 * ManageNav - Sub-navigation for Manage section
 *
 * Shows tabs for accessible sub-sections based on user role.
 * Uses hash-based routing for sub-sections.
 */

import clsx from 'clsx';
import styles from './ManageNav.module.css';

const NAV_ITEMS = [
  { key: 'dashboard', hash: '', label: 'Overview', access: 'all' },
  { key: 'training', hash: 'training', label: 'Training', access: 'all' },
  { key: 'teams', hash: 'teams', label: 'Teams', access: 'teams' },
  { key: 'persons', hash: 'persons', label: 'Persons', access: 'persons' },
  { key: 'unlinked', hash: 'unlinked', label: 'Unlinked', access: 'persons' },
  { key: 'company', hash: 'company', label: 'Company', access: 'manager' },
];

export default function ManageNav({
  currentPath,
  canManagePersons = false,
  canManageTeams = false,
  canManageCompany = false,
}) {
  // Filter items based on permissions
  const visibleItems = NAV_ITEMS.filter((item) => {
    if (item.access === 'all') return true;
    if (item.access === 'persons') return canManagePersons;
    if (item.access === 'teams') return canManageTeams;
    if (item.access === 'manager') return canManageCompany;
    return false;
  });

  // Determine active item from currentPath (e.g., /manage/teams or /manage/company/users)
  const getActiveKey = () => {
    if (currentPath === '/manage') return 'dashboard';
    if (currentPath.startsWith('/manage/company')) return 'company';
    if (currentPath.startsWith('/manage/training')) return 'training';
    if (currentPath.startsWith('/manage/teams')) return 'teams';
    if (currentPath.startsWith('/manage/persons')) return 'persons';
    if (currentPath.startsWith('/manage/unlinked')) return 'unlinked';
    return 'dashboard';
  };

  const activeKey = getActiveKey();

  const handleNavigate = (hash) => {
    // Use hash-based routing
    if (hash) {
      window.location.hash = hash;
    } else {
      // Clear hash for dashboard
      window.history.pushState({}, '', '/manage');
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  };

  return (
    <nav className={styles.nav}>
      {visibleItems.map((item) => (
        <button
          key={item.key}
          className={clsx(styles.navItem, activeKey === item.key && styles.active)}
          onClick={() => handleNavigate(item.hash)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
}
